import { authorizeMe, axiosInstance } from './commonHeadApiLogic.js';

const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe();
    return await apiFunction(...args);
  } catch (error) {
    console.error("Error in API request:", error);
    throw error;
  }
};

export const getPhotographyPlansAPI = (page = 1, limit = 10, category = 'standard') => {
  return withAuthorization(() =>
    axiosInstance.get(`/api/admins/team-shoot-plans/${category}?page=${page}&limit=${limit}`)
  );
};

export const createPhotographyPlanAPI = (payload) => {
  return withAuthorization(() =>
    axiosInstance.post(`/api/admins/team-shoot-plans`, payload)
  );
};

export const updatePhotographyPlanAPI = (id, payload) => {
  return withAuthorization(() =>
    axiosInstance.put(`/api/admins/team-shoot-plans/${id}`, payload)
  );
};

export const deletePhotographyPlanAPI = (id) => {
  return withAuthorization(() =>
    axiosInstance.delete(`/api/admins/team-shoot-plans/${id}`)
  );
};
